import { render, staticRenderFns } from "./typesetting6.vue?vue&type=template&id=b9a0120e&scoped=true&"
import script from "./typesetting6.vue?vue&type=script&lang=js&"
export * from "./typesetting6.vue?vue&type=script&lang=js&"
import style0 from "./typesetting6.vue?vue&type=style&index=0&id=b9a0120e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a0120e",
  null
  
)

export default component.exports